<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image
            >员工基础信息
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="username" label="员工姓名">
                <el-input
                  v-model="form.username"
                  clearable
                  autocomplete="off"
                  maxlength="30"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="phone" label="手机号码（平台登录账号）">
                <el-input
                  v-model="form.phone"
                  clearable
                  maxlength="11"
                  autocomplete="off"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="deptId" label="所属部门">
                <custom-cascader v-model="form.deptId"></custom-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="userType" label="岗位标签">
                <el-select
                  style="width: 100%"
                  v-model="form.userType"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.jobLabelOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>系统角色
          </div>
          <div class="role-data">
            <el-form-item prop="roleIds">
              <el-checkbox-group v-model="form.roleIds">
                <el-checkbox
                  v-for="item in roleList"
                  :label="item.roleId"
                  :key="item.roleId"
                  >{{ item.roleName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addInfo, editInfo, detailInfo } from "./api";
import CustomCascader from "@/components/CustomCascader.vue";
import { validatePhone } from "@/utils/validate";
export default {
  name: "AddOrEdit",
  components: {
    CustomCascader,
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "添加员工",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      cheImage: require("@/assets/imgs/title.png"),
      roleList: [],
      form: {
        userId: "",
        account: "",
        deptId: "",
        password: "",
        phone: "",
        roleIds: [],
        userType: "",
        username: "",
      },
      rules: {
        username: [{ required: true, message: "员工姓名不能为空" }],
        phone: [
          { required: true, message: "手机号码不能为空" },
          { validator: validatePhone, trigger: "blur" },
        ],
        deptId: [{ required: true, message: "部门不能为空" }],
        userType: [{ required: true, message: "标签不能为空" }],
        roleIds: [{ required: true, message: "角色不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    init(roleData, row) {
      this.roleList = [...roleData];
      if (!!row) {
        this.getDetail(row.userId);
      }
      this.dialogObj.show = true;
    },
    getDetail(userId) {
      detailInfo(userId).then((res) => {
        if (res.code === 200) {
          res.data.roleIds = res.data.roles.map((r) => r.roleId);
          this.form = res.data;
        }
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.userId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            userId: this.form.userId,
            userType: this.form.userType,
            account: this.form.account,
            deptId: this.form.deptId,
            phone: this.form.phone,
            username: this.form.username,
            roleIds: this.form.roleIds,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.userId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(
                  this.form.userId ? "edit" : "add",
                  "deptId"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .tip {
    font-size: 0.12rem;
    padding-left: 0.1rem;
    color: #999999;
  }
}
</style>
